import { gameMigrate } from '../game/items.js';
import { renderBuddy } from '../progress/xp.js';
import { collectionCards } from '../views/dashboard.js';
import { dbAll, dbGet, normalizeCard, normalizeDeck } from './db.js';
import { state } from './state.js';

/* ══════════ Deko ══════════ */
export const EXTS = ['png', 'jpg', 'jpeg', 'webp', 'gif'];
export const probe = (src) => new Promise((res) => {
  const img = new Image();
  img.onload = () => res(src); img.onerror = () => res(null); img.src = src;
});
export async function loadDeco() {
  // Eigenes Maskottchen-Bild? (bilder/buddy.png o.ä.)
  for (const ext of EXTS) { const hit = await probe(`bilder/buddy.${ext}`); if (hit) { state.buddyImg = hit; break; } }
  renderBuddy();
}

/* ══════════ Laden ══════════ */
export async function loadAll() {
  const [courses, decks, cards, log, goals, progress, profile, cal] = await Promise.all([
    dbAll('courses'), dbAll('decks'), dbAll('cards'), dbAll('log'),
    dbGet('meta', 'goals'), dbGet('meta', 'progress'), dbGet('meta', 'profile'), dbGet('meta', 'calendar'),
  ]);
  if (profile?.value) state.profile = { ...state.profile, ...profile.value };
  state.courses = courses.sort((a, b) => a.created - b.created);
  state.decks = decks.map(normalizeDeck).sort((a, b) => a.created - b.created);
  state.cards = cards.map(normalizeCard);
  state.log = log;
  if (goals?.value) state.goals = goals.value;
  if (progress?.value) {
    const p = progress.value;
    state.progress = {
      rated: p.rated || 0,
      xp: Number.isFinite(p.xp) ? p.xp : (p.rated || 0) * 10,   // Migration: alte Stände bekommen 10 XP/Karte
      coins: p.coins || 0, gems: p.gems || 0,
      equipped: p.equipped || null,
      unlocked: p.unlocked || [],
      owned: p.owned || [], room: p.room || [],
      freezes: p.freezes || 0, frozen: p.frozen || [], lastBonus: p.lastBonus || '',
      roomTheme: p.roomTheme || 'default', catColor: p.catColor || 'orange',
      ownedThemes: p.ownedThemes || [], ownedColors: p.ownedColors || [],
      best: p.best || { correct: 0, wrong: 0 },
      cur: p.cur || { correct: 0, wrong: 0 },
      remindersOff: p.remindersOff || false,
      game: gameMigrate(p.game),
    };
  }
  if (cal?.value) state.cal = { events: cal.value.events || [], blocked: cal.value.blocked || [] };
  // Die Hochschulliste kam früher aus einem Fremddienst und lag hier zwischen-
  // gespeichert. Sie steht jetzt fest im Code (UNI_FALLBACK), siehe loadUnis().
  state.unis = [];
}

export const visCourses = () => state.courses.filter((c) => state.showArchived || !c.archived);
export const decksOf = (id) => state.decks.filter((d) => d.courseId === id && (state.showArchived || !d.archived));
export const cardsOfDeck = (id) => state.cards.filter((c) => c.deckId === id);
export const cardsOfCourse = (id) => {
  const ok = new Set(decksOf(id).map((d) => d.id));
  return state.cards.filter((c) => c.courseId === id && ok.has(c.deckId));
};

export function scopedCards() {
  if (state.coll) return collectionCards(state.coll);
  if (!state.selCourse) return [];
  if (!state.selDecks.size) return cardsOfCourse(state.selCourse);
  return state.cards.filter((c) => state.selDecks.has(c.deckId));
}
export function scopeLabel() {
  if (!state.selCourse) return 'Nichts ausgewählt';
  const course = state.courses.find((c) => c.id === state.selCourse);
  if (!course) return 'Nichts ausgewählt';
  if (!state.selDecks.size) return `Ganzer Kurs: ${course.name}`;
  const names = [...state.selDecks].map((id) => state.decks.find((d) => d.id === id)?.name).filter(Boolean);
  return `${course.name} · ${names.join(', ')}`;
}
export const dueCount = (cards) => cards.filter((c) => (c.due || 0) <= Date.now()).length;

